import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const PhoneIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="Phone" viewBox="0 0 24 25" {...props}>
      <path
        d="M14.9453 4.3501C16.2167 4.69204 17.376 5.36206 18.307 6.29304C19.238 7.22402 19.908 8.38329 20.2499 9.65472"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1689 7.24854C14.9318 7.4537 15.6274 7.85571 16.186 8.4143C16.7445 8.97289 17.1466 9.66845 17.3517 10.4313"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66965 12.3015C9.44762 13.892 10.7369 15.1754 12.3309 15.9461C12.4475 16.0014 12.5765 16.0253 12.7052 16.0156C12.8339 16.0059 12.9579 15.9628 13.0648 15.8906L15.4119 14.3255C15.5157 14.2563 15.6352 14.214 15.7594 14.2026C15.8837 14.1912 16.0088 14.211 16.1235 14.2601L20.5144 16.142C20.6636 16.2053 20.7881 16.3155 20.8693 16.4557C20.9504 16.596 20.9838 16.7589 20.9643 16.9198C20.8255 18.0058 20.2956 19.004 19.4739 19.7274C18.6521 20.4509 17.5948 20.85 16.5 20.8501C13.1185 20.8501 9.87548 19.5068 7.48439 17.1157C5.0933 14.7246 3.75 11.4816 3.75 8.10007C3.75006 7.00523 4.14918 5.94795 4.87264 5.1262C5.5961 4.30445 6.59428 3.77457 7.68028 3.63579C7.84117 3.61632 8.00403 3.64966 8.14432 3.73079C8.28461 3.81193 8.39473 3.93646 8.4581 4.08562L10.3416 8.48042C10.3903 8.5941 10.4101 8.71805 10.3994 8.84126C10.3886 8.96446 10.3475 9.08309 10.2798 9.18657L8.72011 11.5697C8.64912 11.6769 8.60716 11.8007 8.59831 11.9289C8.58947 12.0572 8.61405 12.1856 8.66965 12.3015V12.3015Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
